import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DynamicSelect from "../DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "../DynamicSelect/model/DynamicSelectConfig";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import axios from "axios";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";

@Component({
  name: "SearcherField",
  components: {
    DynamicSelect
  }
})
export default class SearcherField extends Vue {
  @Prop() schema!: GroupFullSchema;
  @Prop() value!: any;

  requiredFieldSelect = [FORM_VALIDATORS.REQUIRED_FIELD];
  searcherModel: {
    id: string;
    name: string;
    codeCie10?: string;
    cie10name?: string;
    cie11code?: string;
    cie11name?: string;
  }[] = [
    {
      id: "",
      name: "",
      codeCie10: "",
      cie10name: "",
      cie11code: "",
      cie11name: ""
    }
  ];
  searcherConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    chips: false,
    notFound: false,
    listAll: [],
    filled: false,
    messageLabel: "",
    hideDetails: false,
    required: true
  };

  mounted() {
    this.preloadData(this.value);
  }

  @Watch("searcherModel", { deep: true })
  onValueChange() {
    console.log("searcherModel", this.searcherModel);
    this.$emit("update", this.searcherModel);
  }

  async loadItems(query: string) {
    console.log("query", query);
    if (this.schema.searcher == "cie10") {
      const response = await axios.get(
        "https://rda-503334291954.us-east1.run.app/cie10-searcher" +
          "?q=" +
          encodeURIComponent(query) +
          "&lang=es"
      );
      console.log("response", response);
      if (
        response.status === 200 &&
        response.data.destinationEntities.length > 0
      ) {
        console.log("entro");
        this.searcherConfig.listAll = response.data.destinationEntities.map(
          (item: any) => {
            return {
              id: item.id,
              name: item.theCode + " " + item.title,
              codeCie10: item.codeCie10,
              cie10name: item.titleCie10,
              cie11code: item.theCode,
              cie11name: item.title
            };
          }
        );
      }
    }
  }

  preloadData(value: any) {
    console.log("value", value);
    this.searcherConfig.listAll = [
      {
        id: value.id,
        name: value.name,
        codeCie10: value.codeCie10,
        cie10name: value.titleCie10,
        cie11code: value.theCode,
        cie11name: value.title
      }
    ];
    this.searcherModel = [
      {
        id: value.id,
        name: value.name,
        codeCie10: value.codeCie10,
        cie10name: value.titleCie10,
        cie11code: value.theCode,
        cie11name: value.title
      }
    ];
  }
}
